import script from "./purchasereturnlist.vue?vue&type=script&setup=true&lang=js"
export * from "./purchasereturnlist.vue?vue&type=script&setup=true&lang=js"

import "./purchasereturnlist.vue?vue&type=style&index=0&id=49d91c12&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49d91c12"]])

export default __exports__